import axios from "axios";

const USER_BASE_URL = "https://app-apim-admin-cms-stage-erhsf2bafdenc7ft.australiasoutheast-01.azurewebsites.net/";
const CMS_BASE_URL = "https://api-stage.synnexb2b.com.au/stage";

const userApi = axios.create({
  baseURL: USER_BASE_URL,
});

const handleLogout = () => {
  Object.keys(localStorage).forEach(key => {
    if (key !== 'dark_mode') {
      localStorage.removeItem(key);
    }
  });
  window.location.href = "/welcome";
};

userApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

// Orchid Core CMS Base URL
const cmsApi = axios.create({
  baseURL: CMS_BASE_URL,
});
export { userApi, cmsApi };